// extracted by mini-css-extract-plugin
module.exports = {"add":"justForYouContent_add__1PlcS"};